import { WebUserDataConstants } from '../constants/web-user-data.constants';
import { PortfolioFlagsEnum } from '../enums/portfolio-flags.enum';
import { AssetClassExposure } from './asset-class-exposure.interface';
import { BaseModel } from './base-model.interface';
import { Holding } from './holding.interface';
import { UserPerms } from './user-perms.interface';

/**
 * @deprecated Use Portfolio instead
 * TODO dcostea: Merge this with the newer version of Portfolio
 */
export class OldPortfolio {
	public assetClassExposures: Array<AssetClassExposure> = new Array<AssetClassExposure>();
	public modifiedByDifferentUser: boolean = false;
	public createdByDifferentUser: boolean = false;
	public action: string = '';
	public asOfDate: number = 0;
	public baseModel: BaseModel;
	public dateLastShared: Date;

	constructor(
		public name: string,
		public lastModifiedDate: number,
		public lastModifyingUser: string,
		public holdings: Holding[],
		public uniqueId: string,
		public type: string,
		public subType: string,
		public owner: string,
		public dateCreated: number,
		public value: number,
		public userPerms: UserPerms = new UserPerms([]),
		public readonly flags: PortfolioFlagsEnum[] = [],
		public outputDesignation?: string,
		public portfolioType?: string,
		public portfolioKey?: string,
		public baseEngagement?: string,
		public baseEngagementPortfolio?: string
	) { }

	public getName(): string {
		return this.name;
	}

	public getLastModifiedDate(): number {
		return this.lastModifiedDate;
	}

	public getLastModifyingUser(): string {
		return this.lastModifyingUser;
	}

	public getHoldings(): Holding[] {
		return this.holdings;
	}

	public getUniqueId(): string {
		return this.uniqueId;
	}

	public getType(): string {
		return this.type;
	}

	public setType(type: string): string {
		return (this.type = type);
	}

	public getSubType(): string {
		return this.subType;
	}

	public setSubType(subType: string): string {
		return (this.subType = subType);
	}

	public setAction(action): void {
		this.action = action;
	}

	public getAsOfDate(): number {
		return this.asOfDate;
	}

	public setAsOfDate(asOfDate): void {
		this.asOfDate = asOfDate;
	}

	public isBuiltWithHoldings(): boolean {
		return (
			(this.type === WebUserDataConstants.TYPE.PORTFOLIO_LIKE && this.subType === WebUserDataConstants.SUBTYPE.TAX_REPORT) ||
			this.holdings.some(holding => holding.getSubType().toUpperCase() === WebUserDataConstants.CHILD_SUBTYPE.HOLDING)
		);
	}

	public getOwner(): string {
		return this.owner;
	}

	public isModifiedByDifferentUser(): boolean {
		return this.modifiedByDifferentUser;
	}

	public setModifiedByDifferentUser(modified: boolean): void {
		this.modifiedByDifferentUser = modified;
	}

	public isCreatedByDifferentUser(): boolean {
		return this.createdByDifferentUser;
	}

	public setCreatedByDifferentUser(createdByDifferentUser: boolean): void {
		this.createdByDifferentUser = createdByDifferentUser;
	}

	public getValue(): number {
		return this.value;
	}

	public getFlags(): PortfolioFlagsEnum[] {
		return this.flags;
	}

	public getUserPerms(): UserPerms {
		return this.userPerms;
	}

	public getCreationDate(): number {
		return this.dateCreated;
	}

	public getBaseModel(): BaseModel {
		return this.baseModel;
	}

	public setBaseModel(baseModel: BaseModel): void {
		this.baseModel = baseModel;
	}

	public getOutputDesignation(): string {
		return this.outputDesignation;
	}
	public setOutputDesignation(value: string): void {
		this.outputDesignation = value;
	}

	public getBaseEngagement(): string {
		return this.baseEngagement;
	}

	public getBaseEngagementPortfolio(): string {
		return this.baseEngagementPortfolio;
	}

	public isModifiedByOwner(): boolean {
		if (!this.getOwner() || !this.getLastModifyingUser()) {
			return false;
		} else {
			return this.getOwner().toUpperCase() === this.getLastModifyingUser().toUpperCase();
		}
	}
}
